import { useState } from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import AdminLoginCard from '../../../Compnents/Admin/AdminLoginCard'
import RegisterCard from '../../../Compnents/Auth/RegisterCard'

const AdminLogin = () => {

    const [authType, setAuthType] = useState("signin")

    return (
        <>
            <section className='mt-5'>
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <h3 className='text-center fw-bold'>Popgop Referral System</h3>
                            <p className='text-center'>Sign in to manage your referral and earning</p>
                            <div className='d-none p-1 bg-light shadow-sm rounded'>
                                <ButtonGroup className='w-100' aria-label="Basic example">
                                    <Button onClick={() => setAuthType("signin")} variant={authType === "signin" ? "secondary" : ""}>Login</Button>
                                    <Button onClick={() => setAuthType("register")} variant={authType === "register" ? "secondary" : ""}>Register</Button>
                                </ButtonGroup>
                            </div>

                            {authType === "register" ? (
                                <>
                                    <RegisterCard />
                                </>
                            ) : (
                                <>
                                    <AdminLoginCard />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default AdminLogin